/*
 *  -----------------------------------------------------------------------
 *    <copyright file="manage-observation.helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { notEmpty } from '@utils/utility-helpers';
import {
    PanelForObservationFields,
    DashboardFields,
    DashboardFields_Dashboard_panels_DashboardParentPanel as DashboardFields_panels,
} from '@queries/generated/fragments.generated';

export const getActivePanels = (panels: PanelForObservationFields[]) =>
    panels.filter((panel: PanelForObservationFields) => panel.active);

export const getDashboardPanels = (dashboards: DashboardFields[], panels: PanelForObservationFields[]) => {
    const newPanels: PanelForObservationFields[] = [];

    if (dashboards) {
        dashboards.forEach((dashboard: DashboardFields) => {
            dashboard.panels?.filter(notEmpty).forEach((dashboardPanel: DashboardFields_panels) => {
                const findPanel = panels.find(
                    (fullPanel) =>
                        fullPanel.id === dashboardPanel.panelId &&
                        fullPanel.active &&
                        newPanels.findIndex((newPanel) => newPanel.id === fullPanel.id) === -1,
                );

                if (findPanel) newPanels.push(findPanel);
            });
        });
    }

    return newPanels;
};
